export default __webpack_public_path__ + "static/media/not_signed_in_default.dbd87dab.svg";